import React from 'react'
import icon from '../../../assets/cable-icon.svg'

import classes from './CableIcon.module.scss'
import classNames from 'classnames'

type direction = 'left' | 'right'

export const CableIcon: React.FC<{ direction?: direction }> = ({
  direction = 'right'
}) => {
  return (
    <div
      className={classNames(classes.Container, {
        [classes.LeftCable]: direction === 'left',
        [classes.RightCable]: direction === 'right'
      })}
    >
      <img src={icon} alt="Cable Icon" className={classNames(classes.Image)} />
    </div>
  )
}
